import { render, staticRenderFns } from "./RejectedLabels.vue?vue&type=template&id=529e5c98&scoped=true&"
import script from "./RejectedLabels.vue?vue&type=script&lang=js&"
export * from "./RejectedLabels.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=529e5c98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e5c98",
  null
  
)

export default component.exports